import React, { Component } from "react";
import { connect } from "react-redux";
import { Label, Input, Card } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import Dropzone from "react-dropzone";
import moment from "moment";

import { toBase64 } from "common/helper/utilities";
import { HomeLayout, Button } from "components";
import { super_Api_Req } from "common/services";
import { actions } from "../../../../redux/actions/actions";

export const rewardsValidator = Yup.object().shape({
    itemName: Yup.string().required("This Field is required."),
    points: Yup.string().required("This Field is required."),
    stocklist: Yup.string().required("This Field is required."),
    file: Yup.string().required("This Field is required."),
});

class SuperAdminRewardsAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleSubmit = async (v) => {
        const { history } = this.props;
        const fileBase64 = await toBase64(v.file[0]);
        const today = new Date();
        const payload = {
            ItemName: v.itemName,
            ItemDescription: "",
            Points: v.points,
            Quantity: v.stocklist,
            Image: fileBase64,
            StartDateUTC: moment(today).format("YYYY/MM/DD"),
            EndDateUTC: moment(today).add("years", 1).format("YYYY/MM/DD"),
        };
        super_Api_Req.post
            .addRewards(payload)
            .then((resp) => {
                this.props.alertSuccess(resp.data.message);
                history.goBack();
            })
            .catch((err) => {
                this.props.alertError(err);
            });
    };

    render() {
        return (
            <HomeLayout role="super-admin">
                <div className="super-container s-rewards-add-container">
                    <div className="ecp-header-container">
                        <h1 className="ecp-title">ADD REWARDS</h1>
                    </div>
                    <div className="form-container">
                        <Formik
                            initialValues={{
                                itemName: "",
                                points: "",
                                stocklist: "",
                                file: "",
                            }}
                            validationSchema={rewardsValidator}
                            onSubmit={(values, { setSubmitting }) => {
                                setSubmitting(false);
                                this.handleSubmit(values);
                            }}>
                            {(props) => {
                                const { touched, errors, isSubmitting, handleBlur, handleChange, handleSubmit, setFieldValue, values } = props;
                                console.log(values);
                                const errItemName = errors.itemName && touched.itemName ? "error" : "";
                                const errPoints = errors.points && touched.points ? "error" : "";
                                const errStocklist = errors.stocklist && touched.stocklist ? "error" : "";
                                const errFile = errors.file && touched.file ? "error" : "";
                                const file = values.file ? values.file[0].name : "";
                                return (
                                    <form onSubmit={handleSubmit} className="form-wrapper">
                                        <div className="input-col">
                                            <div className="input-container">
                                                <Label>ITEM NAME*</Label>
                                                <Input className={`text-input ${errItemName}`} id="itemName" value={values.itemName} onChange={handleChange} onBlur={handleBlur} />
                                                {errors.itemName && touched.itemName && <div className="input-feedback">{errors.itemName}</div>}
                                            </div>
                                            <div className="input-container">
                                                <Label>POINTS(PT)*</Label>
                                                <Input className={`text-input ${errPoints}`} id="points" value={values.points} onChange={handleChange} onBlur={handleBlur} />
                                                {errors.points && touched.points && <div className="input-feedback">{errors.points}</div>}
                                            </div>
                                            <div className="input-container">
                                                <Label>STOCKLIST*</Label>
                                                <Input className={`text-input ${errStocklist}`} id="stocklist" value={values.stocklist} onChange={handleChange} onBlur={handleBlur} />
                                                {errors.stocklist && touched.stocklist && <div className="input-feedback">{errors.stocklist}</div>}
                                            </div>
                                            <Card className={`drop-file-zone ${errFile}`}>
                                                <Dropzone onDrop={(file) => setFieldValue("file", file)}>
                                                    {({ getRootProps, getInputProps }) => (
                                                        <section>
                                                            <div {...getRootProps()} className="drop-file">
                                                                <p className="desc">{file || `DROP IMAGES here`}</p>
                                                                <p className="desc">- or -</p>
                                                                <input {...getInputProps()} accept="image/*" />
                                                                <Button type="button" title={file ? "REUPLOAD FILE" : "SELECT FILE"} />
                                                            </div>
                                                        </section>
                                                    )}
                                                </Dropzone>
                                            </Card>
                                            {errors.file && touched.file && <div className="input-feedback">{errors.file}</div>}
                                            <div className="button-container">
                                                <Button type="submit" title="SAVE" disabled={isSubmitting} />
                                                <Button title="CANCEL" type="button" outline onClick={this.props.history.goBack} />
                                            </div>
                                        </div>
                                    </form>
                                );
                            }}
                        </Formik>
                    </div>
                </div>
            </HomeLayout>
        );
    }
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => ({
    alertError: (data) => dispatch({ type: actions.ERROR_ALERT, data }),
    alertSuccess: (data) => dispatch({ type: actions.SUCCESS_ALERT, data }),
    fetchSuperSummary: () => dispatch({ type: actions.FETCH_SUPER_SUMMARY }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SuperAdminRewardsAdd);
